import { getVoucherUnitPrice } from '../Context/Voucher/VoucherContext';
import { getAddonPrice } from './addonPricing';

/** Stable grouping for cart display. Never mutates the selected units. */
export const groupSelectedItems = (items, getKey) => {
  if (!Array.isArray(items)) return [];
  const groups = new Map();
  items.forEach((item, index) => {
    if (!item) return;
    const key = getKey(item, index);
    if (!groups.has(key)) groups.set(key, { key, items: [], firstIndex: index });
    groups.get(key).items.push(item);
  });
  return Array.from(groups.values());
};

const servicePrice = (item) => Number(item.price_rate?.member_after_6_or_weekends) || 0;
const sumPrices = (items) => items.reduce((total, item) => total + servicePrice(item), 0);

export const buildVoucherBreakdownRows = (selectedVouchers = []) =>
  groupSelectedItems(selectedVouchers, (voucher, index) => voucher.id == null
    ? `voucher:${index}`
    : `${voucher.category_id ?? 'uncategorized'}:${String(voucher.id)}`
  ).map(({ key, items, firstIndex }) => {
    const voucher = items[0];
    // Voucher carts also support legacy records containing a grouped count.
    const quantity = items.reduce((count, item) =>
      Math.max(count, Math.trunc(Number(item.count) || 0)), items.length);
    const name = voucher.name || `Voucher ${firstIndex + 1}`;
    return {
      key,
      name: voucher.duration ? `${voucher.duration} Mins ${name}` : name,
      quantity,
      lineTotal: getVoucherUnitPrice(voucher) * quantity,
    };
  });

export const buildServiceBreakdownRows = (selectedServices = [], priceAddon = getAddonPrice) =>
  groupSelectedItems(selectedServices, (service, index) => service.id == null
    ? `service:${index}`
    : JSON.stringify([String(service.id), String(service.duration ?? '')])
  ).map(({ key, items }) => ({
    ...items[0],
    key,
    // Service count is a slot identifier, not the selected quantity.
    quantity: items.length,
    lineTotal: sumPrices(items),
    selectedAddons: groupSelectedItems(
      items.flatMap((service) => service.selectedAddons || []),
      (addon, index) => addon.id == null ? `addon:${index}` : String(addon.id)
    ).map(({ key: addonKey, items: addons }) => ({
      key: addonKey,
      name: addons[0].name,
      quantity: addons.length,
      lineTotal: addons.reduce((total, addon) => total + priceAddon(addon), 0),
    })),
  }));
